import { Box, styled } from "@mui/material";

export const StyledWrapper = styled(Box)(({ theme }) => ({
  position: "absolute",
  inset: 0,
  zIndex: 3,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "clamp(20px, 3.5vw, 56px)",
  padding: "60px 80px",
  [theme.breakpoints.down("lg")]: {
    padding: "40px 48px",
  },
  [theme.breakpoints.down("md")]: {
    padding: "32px 28px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "20px 16px",
  },

  ".hero-title": {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    columnGap: "clamp(10px, 1.6vw, 28px)",
    rowGap: 0,
    fontFamily: "Inter",
    lineHeight: 0.95,
    margin: 0,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      rowGap: "6px",
    },
    "& .title-stroke": {
      color: "transparent",
      WebkitTextStroke: "2px #fff",
      fontWeight: 900,
      fontSize: "clamp(40px, 9vw, 115px)",
      letterSpacing: "0.05em",
      textTransform: "uppercase",
      [theme.breakpoints.down("xs")]: {
        WebkitTextStroke: "1.5px #fff",
      },
    },
    "& .title-of": {
      color: "#fff",
      fontWeight: 700,
      fontSize: "clamp(14px, 2vw, 30px)",
      lineHeight: 1,
    },
    "& .title-solid": {
      color: "#fff",
      fontWeight: 900,
      fontSize: "clamp(40px, 9vw, 115px)",
      letterSpacing: "0.05em",
      textTransform: "uppercase",
    },
  },

  // Elrejtve a jövő évi rendezvényig - jövőre újra kell aktiválni
  // ".cinema-pill": {
  //   display: "inline-flex",
  //   alignItems: "center",
  //   gap: "0.4em",
  //   border: "1.4px solid #EB0028",
  //   borderRadius: "10px",
  //   padding: "10px 22px",
  //   color: "#fff",
  //   fontFamily: "Inter",
  //   fontSize: "clamp(11px, 1.6vw, 22px)",
  //   lineHeight: 1.2,
  //   textTransform: "uppercase",
  //   whiteSpace: "nowrap",
  //   backgroundColor: "transparent",
  //   maxWidth: "100%",
  //   "& .cinema-name": { fontWeight: 900 },
  //   "& .separator": { fontWeight: 400 },
  //   "& .date-text": { fontWeight: 700 },
  //   "& .date-year": { fontWeight: 400 },
  //   [theme.breakpoints.down("xs")]: {
  //     whiteSpace: "normal",
  //     flexWrap: "wrap",
  //     justifyContent: "center",
  //     textAlign: "center",
  //     padding: "8px 16px",
  //   },
  // },
}));
